export const MID_FORM_SAMPLE_TITLE = '중간검사성적서';

export const MID_FORM_SAMPLE_MEMO =
  '검사 항목은 중간검사 등록 시 직접 추가하거나, 이전 작성을 불러와 입력합니다.';

/** 중간검사 요구사항 섹션 (기존 외관/전기/에이징 통합) */
export const MID_PROCESS_REQUIREMENT = '요구사항';

export const MID_HEADER_META_FIELDS = [
  { label: '모델명', hint: '재고 품목 선택' },
  { label: 'LOT NO.', hint: '실행 시 입력' },
  { label: 'LOT 수량', hint: '실행 시 입력' },
  { label: '검사 일자', hint: '실행 시 입력' },
  { label: '검사자', hint: '실행 시 입력' },
] as const;
